import { WindowActions } from 'epics/windowEpic'
import React from 'react'
import { useDispatch } from 'react-redux'
import { HeroPanel } from './HeroPanel'

interface ConnectedHeroPanelProps {
  tearoutUrl: string
  children?: React.ReactNode
}

export const ConnectedHeroPanel: React.FC<ConnectedHeroPanelProps> = ({ children, tearoutUrl }) => {
  const dispatch = useDispatch()
  return <HeroPanel onTearout={() => dispatch(WindowActions.tearoutGrid(tearoutUrl))}>{children}</HeroPanel>
}
